/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfSchemaCatalogResponse } from '../model';
// @ts-ignore
import { ApiResponseOfSchemaCatalogResponseArray } from '../model';
// @ts-ignore
import { SchemaCatalogBody } from '../model';
/**
 * SchemaCatalogApi - axios parameter creator
 * @export
 */
export const SchemaCatalogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new schema
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (schemaCatalogBody: SchemaCatalogBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaCatalogBody' is not null or undefined
            assertParamExists('create', 'schemaCatalogBody', schemaCatalogBody)
            const localVarPath = `/api/v1/schemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schemaCatalogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/schemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get schema by ID
         * @param {string} schemaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (schemaId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaId' is not null or undefined
            assertParamExists('getById', 'schemaId', schemaId)
            const localVarPath = `/api/v1/schemas/{schemaId}`
                .replace(`{${"schemaId"}}`, encodeURIComponent(String(schemaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update schema by ID
         * @param {string} schemaId 
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (schemaId: string, schemaCatalogBody: SchemaCatalogBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaId' is not null or undefined
            assertParamExists('update', 'schemaId', schemaId)
            // verify required parameter 'schemaCatalogBody' is not null or undefined
            assertParamExists('update', 'schemaCatalogBody', schemaCatalogBody)
            const localVarPath = `/api/v1/schemas/{schemaId}`
                .replace(`{${"schemaId"}}`, encodeURIComponent(String(schemaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schemaCatalogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaCatalogApi - functional programming interface
 * @export
 */
export const SchemaCatalogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaCatalogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new schema
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(schemaCatalogBody: SchemaCatalogBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSchemaCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(schemaCatalogBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSchemaCatalogResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get schema by ID
         * @param {string} schemaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(schemaId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSchemaCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(schemaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update schema by ID
         * @param {string} schemaId 
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(schemaId: string, schemaCatalogBody: SchemaCatalogBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSchemaCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(schemaId, schemaCatalogBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchemaCatalogApi - factory interface
 * @export
 */
export const SchemaCatalogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaCatalogApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new schema
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(schemaCatalogBody: SchemaCatalogBody, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse> {
            return localVarFp.create(schemaCatalogBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponseArray> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get schema by ID
         * @param {string} schemaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(schemaId: string, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse> {
            return localVarFp.getById(schemaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update schema by ID
         * @param {string} schemaId 
         * @param {SchemaCatalogBody} schemaCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(schemaId: string, schemaCatalogBody: SchemaCatalogBody, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse> {
            return localVarFp.update(schemaId, schemaCatalogBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaCatalogApi - interface
 * @export
 * @interface SchemaCatalogApi
 */
export interface SchemaCatalogApiInterface {
    /**
     * 
     * @summary Create a new schema
     * @param {SchemaCatalogBody} schemaCatalogBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApiInterface
     */
    create(schemaCatalogBody: SchemaCatalogBody, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse>;

    /**
     * 
     * @summary List all schemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApiInterface
     */
    getAll(options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponseArray>;

    /**
     * 
     * @summary Get schema by ID
     * @param {string} schemaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApiInterface
     */
    getById(schemaId: string, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse>;

    /**
     * 
     * @summary Update schema by ID
     * @param {string} schemaId 
     * @param {SchemaCatalogBody} schemaCatalogBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApiInterface
     */
    update(schemaId: string, schemaCatalogBody: SchemaCatalogBody, options?: any): AxiosPromise<ApiResponseOfSchemaCatalogResponse>;

}

/**
 * SchemaCatalogApi - object-oriented interface
 * @export
 * @class SchemaCatalogApi
 * @extends {BaseAPI}
 */
export class SchemaCatalogApi extends BaseAPI implements SchemaCatalogApiInterface {
    /**
     * 
     * @summary Create a new schema
     * @param {SchemaCatalogBody} schemaCatalogBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApi
     */
    public create(schemaCatalogBody: SchemaCatalogBody, options?: any) {
        return SchemaCatalogApiFp(this.configuration).create(schemaCatalogBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all schemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApi
     */
    public getAll(options?: any) {
        return SchemaCatalogApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get schema by ID
     * @param {string} schemaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApi
     */
    public getById(schemaId: string, options?: any) {
        return SchemaCatalogApiFp(this.configuration).getById(schemaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update schema by ID
     * @param {string} schemaId 
     * @param {SchemaCatalogBody} schemaCatalogBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaCatalogApi
     */
    public update(schemaId: string, schemaCatalogBody: SchemaCatalogBody, options?: any) {
        return SchemaCatalogApiFp(this.configuration).update(schemaId, schemaCatalogBody, options).then((request) => request(this.axios, this.basePath));
    }
}
